import React from 'react';
import { SVGHeader } from '../../../Svg/Header';
import { AutoSearchKeywords, SearchIconContainer } from './styled';

function AutoKeywords(props) {
  const { newText, cardEffect, index, autoKeywordsHandler, string } = props;
  return (
    <AutoSearchKeywords
      onClick={(e) => autoKeywordsHandler(e, encodeURIComponent(string), index)}
      className={index === cardEffect ? 'lowOpacity' : ''}
    >
      <SearchIconContainer>
        <SVGHeader id="searchblacknew" />
      </SearchIconContainer>

      <span
        dangerouslySetInnerHTML={{
          __html: newText,
        }}
        className="search_text"
      ></span>
    </AutoSearchKeywords>
  );
}

export default AutoKeywords;
